export enum ModalType {
  AddingCC = 'adding-cc',
  DeletionCC = 'deletion-cc',
}
